<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Expert Availability List</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>
<section class="main-content wrapper content-padding">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
      <form  class="table-row-container row first-row filter" [formGroup]="expertAvailablitiesForm" (ngSubmit)="filter()" *ngIf="expertAvailablitiesForm">
          <div class="item data-col-5">
              <h4 class="title" (click)="navigateOrder('ExpertTimeAvailability.id')">
                <i class="sort-icon fas" [ngClass]="orderIcon('ExpertTimeAvailability.id')"></i>
                ID
              </h4>
              <span class="data">
                <input type="number" min="1000" max="10000" formControlName="ExpertTimeAvailability.id">
              </span>
          </div>

          <div class="item data-col-5 item">
              <h4 class="title" (click)="navigateOrder('ExpertTimeAvailability.date')">
                <i class="sort-icon fas" [ngClass]="orderIcon('ExpertTimeAvailability.date')"></i>
                DATA
              </h4>
              <span class="data">
                <div class="date">Da:</div>
                <input class="date" type="date" formControlName="ExpertTimeAvailability.date_from">
              </span>
              <span class="data">
                <div class="date">A: </div>
                <input class="date" type="date" formControlName="ExpertTimeAvailability.date_to">
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('UserExpert.surname')">
                <i class="sort-icon fas" [ngClass]="orderIcon('UserExpert.surname')"></i>
                Expert
              </h4>
              <span class="data">
                <input type="text" formControlName="UserExpert.surname">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Province1.provinceCode')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Province1.provinceCode')"></i>
                Provincia
              </h4>
              <span class="data">
                <input type="text" formControlName="Province1.provinceCode">  
              </span>
          </div>

          <div  class="item center data-col-5">
            <h4 class="title" (click)="navigateOrder(['ExpertTimeAvailability.startTime'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['ExpertTimeAvailability.startTime'])"></i>
              Availabilitly Timing
            </h4>
            <span class="data">
              <div class="date">Da: </div>
              <input class="date" type="time" formControlName="ExpertTimeAvailability.startTime">
            </span>
            <span class="data">
              <div class="date">A: </div>
              <input class="date" type="time" formControlName="ExpertTimeAvailability.endTime">
            </span>
          </div>

          <div class="item center data-col-5">
            <h4 class="title">Available</h4>
            <span class="data">
              <select formControlName="ExpertTimeAvailability.available">
                <option value="">Tutti</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="fnReset();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
      </form>

      <div class="table-row-container row" *ngFor="let data of availabilityData">
          <div class="item data-col-5">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                ID
              </h4>
              <div class="data data-id">
                <div>
                  <a [routerLink]="['/expert', data?.expert?.id, 'availability']">
                    {{ data?.id || "---" }}
                  </a>
                </div>
              </div>
          </div>

          <div class="item data-col-5">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                DATA :
              </h4>
              <div class="data">
                <div>
                  <a [routerLink]="['/expert', data?.expert?.id, 'availability']">
                    {{ data?.date || "---" }}
                  </a>
                </div>
              </div>
          </div>

          <div class="item data-col-10">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                Expert
              </h4>
              <div class="data">
                <div>
                  <a [routerLink]="['/expert', data?.expert?.id, 'availability']">
                    {{ data?.expert?.user?.surname}} {{data?.expert?.user?.name }}
                  </a>
              </div>
              </div>
          </div>

          
          <div class="item data-col-10">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                Provincia
              </h4>
              <div class="data">
                <div *ngIf="data?.expert?.expertProvinces?.length > 0">
                  <span *ngFor="let item of data?.expert?.expertProvinces; let last = last">
                    <a [routerLink]="['/expert', data?.expert?.id, 'availability']">
                      <b>{{ item?.province?.provinceCode?.toUpperCase() }}</b>
                    </a>
                    <ng-container *ngIf="!last">, </ng-container>
                  </span>
                </div>
                <div *ngIf="data?.expert?.expertProvinces?.length === 0"> 
                  ---
                </div>
              </div>
          </div>
          
          <div class="item data-col-5">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                Availabilitly Timing
              </h4>
              <div class="data">
                <div>
                  <a [routerLink]="['/expert', data?.expert?.id, 'availability']">
                    {{ formatTimeShow(data?.startTime, data?.endTime )}}
                  </a>
                </div>
              </div>
          </div>

          <div class="item center data-col-5">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Available
            </h4>
            <div class="data">
              <div> 
                <a [routerLink]="['/expert', data?.expert?.id, 'availability']">
                  {{ data?.available ? "Yes" : "No"}} 
                </a>
              </div>
            </div>
          </div>

          <div class="item data-col-5">
              <h4 class="title"></h4>
              <!-- <span class="data saifu">
                <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/valet/servizi', expertService?.id, 'edit']">
                  MODIFICA
                </button>
                &nbsp;
                <a (click)="$event.preventDefault(); deleteExpertService(expertService?.id)">
                  <span class="btn btn-red hvr-grow">
                      Elimina
                      <i class="ml-10 far fa-trash-alt"></i>
                  </span>
                </a>
              </span> -->
          </div>
      </div>
  </div>
</section>